<div class="container-fluid p-0">
    <app-header></app-header>
    <div class="page-container page-notification">
        <div class="container">
            <div class="page-action">
                <h2 class="page-title">{{'ad_recharge'|translate}}</h2>
            </div>
            <div class="page-form">
                <div class="row">
                    <div class="col col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
                        <form class="payment-form" [formGroup]="paymentForm"
                            (ngSubmit)="paymentForm.valid && PaymentByBank()">
                            <div class="form-group">
                                <div class="amount-of-money-group">
                                    <label class="control-label" for="amount-of-money">{{'deposit_amount'|translate}}</label>
                                    <input type="text" appAllowDecimalNumber class="form-control" id="amount-of-money"
                                        placeholder="{{'enter_amount'|translate}}" [(ngModel)]="payment.totalAmount"
                                        formControlName="amount">
                                    <span>VNĐ</span>
                                </div>
                                <div *ngIf="paymentForm.controls.amount.invalid && paymentForm.controls.amount.touched"
                                    class="alert alert-danger">
                                    {{_paymentValidateService.PaymentValidate.amountValidate.message(paymentForm.controls.amount)}}
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label" for="bank-name">{{'bank'|translate}}</label>
                                <div class="w-100">
                                    <select class="custom-select" id="bank-name" formControlName="bankCode" [(ngModel)]="payment.bankCode">
                                        <option value="" selected>{{'choose_bank'|translate}}</option>
                                        <option value="VISA">{{'VISA'|translate}}</option>
                                        <option value="VCB">{{'VCB'|translate}}</option>
                                        <option value="DAB">{{'DAB'|translate}}</option>
                                        <option value="TCB">{{'TCB'|translate}}</option>
                                        <option value="MB">{{'MB'|translate}}</option>
                                        <option value="VIB">{{'VIB'|translate}}</option>
                                        <option value="ICB">{{'ICB'|translate}}</option>
                                        <option value="EXB">{{'EXB'|translate}}</option>
                                        <option value="ACB">{{'ACB'|translate}}</option>
                                        <option value="HDB">{{'HDB'|translate}}
                                        </option>
                                        <option value="MSB">{{'MSB'|translate}}</option>
                                        <option value="NVB">{{'NVB'|translate}}</option>
                                        <option value="VAB">{{'VAB'|translate}}</option>
                                        <option value="VPB">{{'VPB'|translate}}</option>
                                        <option value="SCB">{{'SCB'|translate}}</option>
                                        <option value="GPB">{{'GPB'|translate}}</option>
                                        <option value="AGB">{{'AGB'|translate}}</option>
                                        <option value="BIDV">{{'BIDV'|translate}}</option>
                                        <option value="OJB">{{'OJB'|translate}}</option>
                                        <option value="PGB">{{'PGB'|translate}}</option>
                                        <option value="SHB">{{'SHB'|translate}}</option>
                                        <option value="TPB">{{'TPB'|translate}}</option>
                                        <option value="NAB">{{'NAB'|translate}}</option>
                                        <option value="SGB">{{'SGB'|translate}}</option>
                                    </select>
                                </div>
                                <div *ngIf="paymentForm.controls.bankCode.invalid && paymentForm.controls.bankCode.touched"
                                    class="alert alert-danger">
                                    {{_paymentValidateService.PaymentValidate.bankValidate.message(paymentForm.controls.bankCode)}}
                                </div>
                            </div>
                            <div class="form-action">
                                <button class="btn btn-primary" type="submit" [disabled]="paymentForm.invalid" style="background-color: var(--primary); border-color: var(--primary);">{{'li_confirm'|translate}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <footer class="idc-footer">
        <p class="copyright">{{'ldp_copyright'|translate}}</p>
    </footer>
</div>